import { useContext } from "react";
import { motion } from "framer-motion";
import { LanguageContext } from "../../../context/LanguageContext";

export default function Testimonials() {
  const { t, isRTL } = useContext(LanguageContext);
  const testimonials =
    t("testimonials.items", { returnObjects: true }) || [];

  return (
    <section dir={isRTL ? "rtl" : "ltr"} className="bg-indigo-50 py-24">
      <div className="mx-auto max-w-7xl px-6">

        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center"
        >
          <h2 className="text-4xl font-extrabold text-black">
            {t("testimonials.title")}
          </h2>
          <p className="mt-4 text-lg text-gray-600">
            {t("testimonials.subtitle")}
          </p>
        </motion.div>

        {/* Grid */}
        <div className="mt-16 grid grid-cols-1 gap-8 md:grid-cols-3">
          {testimonials.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.15 }}
              whileHover={{ y: -6 }}
              className="rounded-2xl bg-white p-8 shadow-sm"
            >
              {/* Stars */}
              <div className="mb-4 flex space-x-1 text-indigo-600">
                {[...Array(5)].map((_, i) => (
                  <span key={i}>★</span>
                ))}
              </div>

              {/* Quote */}
              <p className="italic text-gray-700 leading-relaxed">
                “{item.quote}”
              </p>

              {/* Profile */}
              <div className={`mt-6 flex items-center gap-4 ${isRTL ? "flex-row-reverse text-right" : ""}`}>
                <img
                  src={item.avatar}
                  alt={item.name}
                  className="h-12 w-12 rounded-full object-cover"
                />
                <div>
                  <p className="font-semibold text-black">
                    {item.name}
                  </p>
                  <p className="text-sm text-gray-600">
                    {item.role}
                    {item.location && ` • ${item.location}`}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

      </div>
    </section>
  );
}
